/**
 * DictionarySyncPanel — zakładka „Słowniki" pulpitu synchronizacji integracji ERP.
 *
 * Słowniki (waluty, stawki VAT, rejestry VAT, urzędy skarbowe, regiony, lata obrachunkowe…) to
 * dane referencyjne — synchronizacja JEDNOKIERUNKOWA (Symfonia → my), bez konfliktów. Przeniesione
 * z przycisku w nagłówku integracji do zakładki, obok Kontrahentów / Pracowników / Dokumentów.
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Library } from 'lucide-react';

import { Button } from '@/components/Button';

import { type ErpIntegrationDto } from './IntegrationsTab';
import { SyncDictionariesModal } from './SyncDictionariesModal';

export function DictionarySyncPanel({ integration }: { integration: ErpIntegrationDto }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const canSync =
    integration.isActive && (integration.connectionMode === 'direct' || integration.agentTokenSet);

  return (
    <div className="rounded-lg border border-border-primary bg-bg-secondary p-4">
      <h4 className="text-sm font-semibold text-text-primary">
        {t('tenant.settings.integrations.sync.dictionariesPanel.title')}
      </h4>
      <p className="mb-3 mt-0.5 text-xs text-text-tertiary">
        {t('tenant.settings.integrations.sync.dictionariesPanel.hint')}
      </p>
      <Button
        variant="primary"
        leftIcon={<Library className="h-4 w-4" />}
        disabled={!canSync}
        onClick={() => setOpen(true)}
        data-testid={`erp-sync-dictionaries-${integration.id}`}
      >
        {t('tenant.settings.integrations.list.actionSyncDictionaries')}
      </Button>

      <SyncDictionariesModal
        open={open}
        integrationId={integration.id}
        integrationName={integration.name}
        onClose={() => setOpen(false)}
      />
    </div>
  );
}
